// @ts-check
// Rotas REST da tela Visitas (docs/arquitetura-appcrm/08-contrato-visitas.md, seção 5).
import { api } from './api-client.js';

/**
 * @typedef {{ id: string, name: string }} NamedRecord
 * @typedef {{ id: string, enrollmentOpportunityId: string, eventType: string, fieldName: string, startsAt: string, endsAt: string,
 *   situation: 'SCHEDULED' | 'ATTENDED' | 'NO_SHOW', needsCheckIn: boolean, attendance: string | null,
 *   card: { id: string, name: string, stage: string | null }, family: NamedRecord | null, contact: NamedRecord | null,
 *   students: Array<{ id: string, personId: string | null, name: string, grade: string | null }>, campus: NamedRecord | null,
 *   host: NamedRecord | null, owner: NamedRecord | null }} VisitItem
 * @typedef {{ value: string, label: string, color: string | null }} OptionValue
 * @typedef {{ card: Record<string, any>, origin: Record<string, any>, interests: Record<string, any>, family: Record<string, any> | null,
 *   guardians: Array<Record<string, any>>, students: Array<Record<string, any>>, siblingsEnrolled: Array<Record<string, any>>,
 *   recentNotes: Array<Record<string, any>> | null, recentMessages: Array<Record<string, any>> | null }} VisitSummary
 * @typedef {{ startsAt: string, endsAt: string, campusId?: string | null, visitHostId?: string | null, situations?: string[], eventTypes?: string[] }} VisitQuery
 */

/**
 * @param {VisitQuery} query
 * @returns {Promise<VisitItem[]>}
 */
export async function listVisits(query) {
  const body = await api.get('/rest/visits', {
    startsAt: query.startsAt,
    endsAt: query.endsAt,
    campusId: query.campusId || undefined,
    visitHostId: query.visitHostId || undefined,
    situations: query.situations?.length ? query.situations.join(',') : undefined,
    eventTypes: query.eventTypes?.length ? query.eventTypes.join(',') : undefined,
  });
  return body?.data?.visits ?? [];
}

/**
 * @param {string} enrollmentOpportunityId
 * @returns {Promise<VisitSummary>}
 */
export async function fetchVisitSummary(enrollmentOpportunityId) {
  const body = await api.get(`/rest/visits/${enrollmentOpportunityId}/summary`);
  return body?.data?.summary;
}

/**
 * @param {string} enrollmentOpportunityId @param {{ attendance: 'SCHEDULED' | 'ATTENDED' | 'NO_SHOW', occurredAt?: string | null }} input
 */
export async function recordVisitAttendance(enrollmentOpportunityId, input) {
  const body = await api.post(`/rest/visits/${enrollmentOpportunityId}/attendance`, input);
  return body?.data?.enrollmentOpportunity;
}

/**
 * @param {string} enrollmentOpportunityId @param {{ body: string, title?: string }} input
 */
export async function addVisitNote(enrollmentOpportunityId, input) {
  const body = await api.post(`/rest/visits/${enrollmentOpportunityId}/notes`, input);
  return body?.data?.note;
}
